import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";

const STC = { Active: "bg-emerald-100 text-emerald-700", Brouillon: "bg-slate-100 text-slate-600", "Clôturée": "bg-amber-100 text-amber-700", "Archivée": "bg-slate-100 text-slate-500" };

export default function Periods() {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/school/periods").then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e.response?.data?.detail))); }, []);
  return (
    <div data-testid="school-periods">
      <h1 className="text-2xl font-display font-bold text-slate-900 mb-6">{t("periods")}</h1>
      <Card className="card-float border-slate-200 overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-slate-50/70 hover:bg-slate-50/70">
            <TableHead>{t("order")}</TableHead><TableHead>{t("name")}</TableHead><TableHead>{t("periodType")}</TableHead><TableHead>{t("status")}</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {rows.map((p) => (
              <TableRow key={p.id} data-testid="period-row">
                <TableCell className="text-slate-400 tabular-nums">{p.order_index}</TableCell>
                <TableCell className="font-medium text-slate-800">{p.name}</TableCell>
                <TableCell className="text-slate-600">{p.period_type || "—"}</TableCell>
                <TableCell><Badge className={`${STC[p.status] || "bg-slate-100"} border-0`}>{p.status}</Badge></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
